import { useClient } from './useClient';
import { PORTAL_BASE } from '../consts';
import { useMutation } from '@tanstack/react-query';
import {
  NotificationType,
  showNotification,
} from '../components/ToastNotification/ToastNotification';

interface SetupCompanyResponse {
  success: boolean;
}

interface SetupCompanyRequest {
  companyName: string;
  howDidYouHearAboutUs?: string;
}

export default function useSetupCompany() {
  const { client, isReady } = useClient();

  const mutation = useMutation({
    mutationFn: async (data: string | SetupCompanyRequest): Promise<SetupCompanyResponse> => {
      if (!client || !isReady) {
        throw new Error('Client is not available');
      }

      const response = await client.put<SetupCompanyResponse>(
        `${PORTAL_BASE}/account/company-name`,
        data
      );
      return response.data;
    },
    onError: () => {
      showNotification({
        type: NotificationType.ERROR,
        message: 'There was an error updating company name',
      });
    },
  });

  return mutation;
}
